//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Grid,
  GridItem,
} from 'vant'
import moreApps from '../../assets/img/more_apps.png'

export default {
  name: 'CAppsGrid',

  components: {
    Grid,
    GridItem,
  },

  props: {
    moreUrl: {
      type: String,
      default: '/',
    },

    num: {
      type: [
        String,
        Number,
      ],
      default: 9,
    },

    columnNum: {
      type: [
        String,
        Number,
      ],
      default: 3,
    },

    border: {
      type: Boolean,
      default: false,
    },

    handlerItem: { type: Function },

    list: {
      type: Array,
      default: () => ([
        {
          img: '',
          name: '我的服务',
          url: '/',
        },
      ]),
    },
  },

  data () {
    return {
      moreApps,
      showList: [],
    }
  },

  watch: {
    list: {
      deep: true,
      immediate: true,
      handler (v) {
        if (!v) {
          return
        }

        if (v.length > this.num) {
          this.showList = v.slice(0, this.num).concat([
            {
              img: moreApps,
              name: '更多应用',
              url: this.moreUrl,
            },
          ])
        } else {
          this.showList = v
        }
      },
    },
  },

  methods: {
    handlerGrid (item) {
      if (this.handlerItem) {
        this.handlerItem(item)
      } else {
        window.location = item.url
      }
    },
  },
}
